import { atom } from "recoil";

const myInfoAtom = atom({

    key:"myInfoState",
    default: {}

});

export default myInfoAtom;